module.exports = __webpack_public_path__ + "assets/img/新闻报道.222bb129.jpg";